export const headerImageSm = require("./header-image-sm.jpg");
export const headerImageLg = require("./header-image-lg.jpg");

export const church = require("./gamla-uppsala-kyrka.svg");
export const lanna = require("./lanna-gard.svg");
export const map = require("./karta.svg");

export const logo = require("./logo.svg");
